import Vue from 'vue'
import {request} from '../utils/request'

// post
export function postAction(url, parameter) {
  return request({
    url: url,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json' // 文件上传
    }
  })
}
// post
export function getActionFile(url, parameter) {
  return request({
    url: url,
    method: 'get',
    data: parameter,
    headers: {
      contentType: 'multipart/form-data' // 文件上传
    }
  })
}
// post
export function postActionFile(url, parameter) {
  return request({
    url: url,
    method: 'post',
    data: parameter,
    headers: {
      contentType: 'multipart/form-data' // 文件上传
    }
  })
}

// post method= {post | put}
export function httpAction(url, parameter, method) {
  return request({
    url: url,
    method: method,
    data: parameter
  })
}

// put
export function putAction(url, parameter) {
  return request({
    url: url,
    method: 'put',
    data: parameter
  })
}

// get
export function getAction(url, parameter) {
  return request({
    url: url,
    method: 'get',
    params: parameter
  })
}

// deleteAction
export function deleteAction(url, parameter) {
  return request({
    url: url,
    method: 'delete',
    params: parameter
  })
}

// id == 0 add     post
// id != 0 update  put
export function saveService(parameter) {
  return request({
    url: api.service,
    method: parameter.id == 0 ? 'post' : 'put',
    data: parameter
  })
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url, parameter) {
  return request({
    url: url,
    params: parameter,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * 下载文件
 * @param url 文件路径
 * @param fileName 文件名
 * @param parameter
 * @returns {*}
 */
export function downloadFile(url, fileName, parameter) {
  return downFile(url, parameter).then((data) => {
    if (!data || data.size === 0) {
      Vue.prototype['$message'].warning('文件下载失败')
      return
    }
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(new Blob([data]), fileName)
    } else {
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) // 下载完成移除元素
      window.URL.revokeObjectURL(url) // 释放掉blob对象
    }
  })
}

/**
 * 文件上传 用于富文本上传图片
 * @param url
 * @param parameter
 * @returns {*}
 */
export function uploadAction(url, parameter) {
  return request({
    url: url,
    data: parameter,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data' // 文件上传
    }
  })
}

// get
export function Logout(url, token) {
  return request({
    url: url,
    method: 'post',
    headers: {
      'X-Access-Token': token // 文件上传
    }
  })
}

// 获取运费
export function getSendFee(url, parameter) {
  return request({
    url: url,
    method: 'get',
    data: parameter
  })
}

/**
 * 预支付、余额接口
 * Author:xionghuchao
 *  get
 * @param {*} url
 * @param {*} token
 * @returns
 */
export function getCreditLimit(url, parameter) {
  return request({
    url: url,
    method: 'get',
    parameter
  })
}

/**
 * 下载http路径文件
 * @param httpurl
 * @Author cpgu 2022/05/09
 */
export function downloadStaticFile(httpurl){
  let link = document.createElement("a");
  //创建一个a标签
  link.style.display = "none";
  //将a标签隐藏
  link.href = httpurl;
  link.target = '_blank'//在新窗口打开
  //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
  link.setAttribute("download", name);
  // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
  document.body.appendChild(link);
  //将上面创建的a标签加入到body的尾部
  link.click();
}



// WEBPACK FOOTER //
// ./src/api/manage.js